module.exports = __webpack_public_path__ + "static/media/bills.39ccb394.jpg";